/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import { Component, OnInit, ChangeDetectorRef, ViewChild } from "@angular/core";
import {
  AccountResourceService,
  PrincipalService,
  ProfileService,
} from "../../../shared";
import { Router } from "@angular/router";
import { LoginService } from "../../../shared";
import { Profile } from "../../../shared/types/profile.type";
import { AccountType } from "../../../shared/types/account.type";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AES, SHA256 } from "crypto-js";
import { BsModalComponent } from "ng2-bs3-modal";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public authenticationError: boolean;
  public successAuthentication: boolean = false;
  public showLoginForm: boolean;
  public password: string;
  public username: string;
  public auth: boolean = false;
  public searchString = null;
  public profile: Profile;
  public account: AccountType;
  public userLocked: boolean = false;
  public passwordExpired: boolean = false;
  public showSpinner: boolean = false;
  public form: FormGroup;

  public otpExceedMessage = false;
  public otpInvalidMessage = false;
  public signInButtonIsDisabled = false;
  public accountIslocked = false;
  public userNotRegistered = false;
  public timeLeft = 30;
  public otpFailedMessage: boolean = false;
  public otpUserEmail: string;
  public otpStatus: string;

  latitude: string;
  longitude: string;
  signature: string;

  @ViewChild("otpModal")
  otpModal: BsModalComponent;
  loadingLogin = false
  statusCode;
  constructor(
    public principal: PrincipalService,
    public loginService: LoginService,
    public router: Router,
    public profileService: ProfileService,
    private fb: FormBuilder
  ) {
    if (this.principal.isAuthenticated()) {
      this.showLoginForm = true;
      this.router.navigate(["/"]);
    } else {
      this.showLoginForm = true;
    }
  }

  ngOnInit() {
    this.initOtpForm();
    this.getDeviceFingerprint();
  }

  initOtpForm() {
    this.form = this.fb.group({
      form1: [""],
      form2: [""],
      form3: [""],
      form4: [""],
      form5: [""],
      form6: [""],
    });
  }

  login() {
    this.accountIslocked = false;
    this.authenticationError = false;
    this.otpExceedMessage = false;

    this.loginService
      .firstLoginMFA(
        this.latitude,
        this.longitude,
        this.signature,
        this.username,
        this.password
      )
      .subscribe((res: any) => {
        const statusCode = res.body.statusCode;
        this.statusCode = res.body.statusCode;
        switch (statusCode) {
          case "AU453": // device login for 2nd time
            new Promise((resolve, reject) => {
              localStorage.setItem("deviceId", res.headers.get("X-Deviceid"));
              let localDeviceId = localStorage.getItem("deviceId");
              resolve(localDeviceId);
            }).then((device) => {
              this.loginService.requestOtp(device).subscribe((res: any) => {
                this.resetState();
                this.otpModal.open();
                this.countdown();
                let statusCode = res.statusCode;
                switch (statusCode) {
                  case "OT000":
                    this.otpUserEmail = res.replyMessageList[0].email;
                    break;
                  case "OT112":
                    this.otpUserEmail = res.replyMessageList[0].email;
                    this.otpExceedMessage = true;
                    break;
                  default:
                    break;
                }
              });
            });

            break;
          case "AU452": // first time login
            new Promise((resolve) => {
              localStorage.setItem("token", res.headers.get("Authorization"));
              let localToken = localStorage.getItem("token");
              resolve(localToken);
            }).then((res) => {
              this.sessionLoginMethod();
            });
            break;
          case "AU000": // successfully register device
            new Promise((resolve) => {
              localStorage.setItem("token", res.headers.get("Authorization"));
              let localToken = localStorage.getItem("token");
              resolve(localToken);
            }).then((res) => {
              this.sessionLoginMethod();
            });
            break;
          case "AU201": // account locked
            this.accountIslocked = true;
            break;
          case "AU104": // account locked
            this.authenticationError = true;
            break;
        }
      });
  }

  async getDeviceFingerprint() {
    return new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(
        (geo) => {
          resolve(geo);
        },
        (err) => {
          resolve(err);
        }
      );
    }).then((geo: any) => {
      if (geo.code == 1) {
        this.latitude = "";
        this.longitude = "";
      } else {
        this.latitude = geo.coords.latitude.toString();
        this.longitude = geo.coords.longitude.toString();
      }
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.userAgent
        .split(") ", 2)[0]
        .split(" (")[1];
      const browser =
        window.navigator.userAgent.split(" ")[
          navigator.userAgent.split(" ").length - 1
        ];
      const sign = userAgent + "#" + platform + "#" + browser;
      const hash = SHA256(sign).toString();
      this.signature = hash;
    });
  }

  loginVerficationButton() {
    this.resetState();
    const mergedOTP =
      this.form.controls["form1"].value +
      this.form.controls["form2"].value +
      this.form.controls["form3"].value +
      this.form.controls["form4"].value +
      this.form.controls["form5"].value +
      this.form.controls["form6"].value;

    // const token = await this.loginService.getLocalToken();
    // const deviceId = await this.loginService.getLocalDeviceId();
    const deviceId = localStorage.getItem("deviceId");

    this.loginService.sendOtp(mergedOTP, deviceId).subscribe((res: any) => {
      new Promise((resolve) => {
        localStorage.setItem("token", res.headers.get("Authorization"));
        let localToken = localStorage.getItem("token");
        resolve(localToken);
      }).then((token) => {
        this.form.reset();
        switch (res.body.statusCode) {
          case "OT001":
            this.sessionLoginMethod();
            break;
          case "OT110":
            this.otpInvalidMessage = true;
            break;
          case "OT112":
            this.otpExceedMessage = true;
            break;
          default:
            break;
        }
      });
    });
  }

  countdown() {
    const timerId = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft === 0) {
        clearInterval(timerId);
      }
    }, 1000);
  }

  sessionLoginMethod() {
    this.loadingLogin = true
    const token = localStorage.getItem("token");
    // const deviceId = localStorage.getItem("deviceId");
    this.loginService.accountSession(token).subscribe(async (session: any) => {
      const account = await this.principal.identity(true);
      localStorage.setItem("account", JSON.stringify(account));
      this.isSuccesLogin();
      this.resetState();
      let showtimeoutClass = document.getElementsByClassName("showclass");
      if (showtimeoutClass.length > 0) {
        console.log(showtimeoutClass);
        document.documentElement.className.replace(
          /(?:^|\s)showclass(?!\S)/,
          ""
        );
        var timeOutClass = document.getElementById("sessionTimeoutModal");
        timeOutClass.className = "";
        timeOutClass.className += "hideClass";
      }
      this.otpModal.close().then( () => {
        this.loadingLogin = false
      })
      // new Promise((resolve) => {
      //   localStorage.setItem("account", JSON.stringify(account));
      //   const localAccount = localStorage.getItem("account");
      //   resolve(localAccount);
      // }).then((acc) => {
      //   this.isSuccesLogin();
      //   this.resetState();
      // });
      // this.resetState();
      // this.authServerProvider
      //   .login({
      //     username: this.username,
      //     password: this.password,
      //   })
      //   .subscribe(async (acc: any) => {
      //     const account = await this.principal.identity(true);
      //     new Promise((resolve) => {
      //       localStorage.setItem("account", JSON.stringify(account));
      //       const localAccount = localStorage.getItem("account");
      //       resolve(localAccount);
      //     }).then((acc) => {
      //       this.isSuccesLogin();
      //     });
      //   });
    });
  }

  isSuccesLogin() {
    this.showLoginForm = false;
    this.successAuthentication = true;
    this.auth = true;
    this.authenticationError = false;
    // this.inProgress = false;
    this.userLocked = false;
    this.passwordExpired = false;
    const urlToRedirection = window.sessionStorage.getItem("url-redirect");
    if (!!urlToRedirection) {
      sessionStorage.removeItem("url-redirect");
      window.location.href =
        window.location.href.split("#")[0] + "/#" + urlToRedirection;
    } else {
      this.router.navigate([""]);
    }
  }

  goToOtpInput(id) {
    if (id) {
      const input = document.getElementById(id) as HTMLInputElement | null;
      input.select();
    }
  }

  onPaste(event: ClipboardEvent) {
    const forms = ["form1", "form2", "form3", "form4", "form5", "form6"];
    let clipboardData = event.clipboardData.getData("text");
    let charArray = clipboardData.split("");
    charArray.forEach((item, index) => {
      this.form.controls[forms[index]].setValue(charArray[index]);
    });
  }

  checkIfNumber(string) {
    return /^[0-9]*$/.test(string);
  }

  otpOnKeypress(event, currentForm, goToform?) {
    if (event.key == "Backspace") {
      // console.log(event.key, event)
    } else {
      new Promise((resolve) => {
        const number = this.checkIfNumber(event.key);
        resolve(number);
      }).then((number) => {
        if (number) {
          this.goToOtpInput(goToform);
          this.form.controls[currentForm].setValue(event.key);
        } else {
          this.form.controls[currentForm].setValue("");
        }
      });
    }
  }

  resendOtp() {
    this.resetState();
    this.timeLeft = 30;
    this.otpFailedMessage = false;
    // const token = await this.loginService.getLocalToken();
    // const deviceId = await this.loginService.getLocalDeviceId();
    const deviceId = localStorage.getItem("deviceId");
    this.loginService.requestOtp(deviceId).subscribe((res: any) => {
      this.otpStatus = res.statusCode;
      this.countdown();
      if (res.statusCode === "OT000") {
        // this.showSpinner = false;
        this.otpUserEmail = res.replyMessageList[0].email;
      } else {
        // this.showSpinner = false;
        this.otpFailedMessage = true;
      }
    });
  }

  resetState() {
    this.accountIslocked = false;
    this.authenticationError = false;
    this.otpExceedMessage = false;
  }

  public isAuthenticated() {
    return this.principal.isAuthenticated();
  }

  public legacyLogin() {
    this.showSpinner = true;
    this.loginService
      .login({
        username: this.username,
        password: this.password,
      })
      .then(() => {
        let showtimeoutClass = document.getElementsByClassName("showclass");
        if (showtimeoutClass.length > 0) {
          console.log(showtimeoutClass);
          document.documentElement.className.replace(
            /(?:^|\s)showclass(?!\S)/,
            ""
          );
          var timeOutClass = document.getElementById("sessionTimeoutModal");
          timeOutClass.className = "";
          timeOutClass.className += "hideClass";
        }

        this.showLoginForm = false;
        this.successAuthentication = true;
        this.auth = true;
        this.authenticationError = false;
        this.userLocked = false;
        this.passwordExpired = false;
        this.showSpinner = false;
        this.profileService.getAuthenticatedMenus().subscribe((menu) => {
          localStorage.setItem("menu", JSON.stringify(menu));
        });

        this.router.navigate([""]);
      })
      .catch((error) => {
        this.showLoginForm = true;
        this.showSpinner = false;
        // LCUS-4971 - show userLocked error when get 403 from BE
        if (error.status == 403) {
          this.userLocked = true;
          this.authenticationError = false;
          this.passwordExpired = false;
          // LCUS-4971 - handle password expired case here
          // } else if(error.status == 420){
          //   this.userLocked = false;
          //   this.authenticationError = false;
          //   this.passwordExpired = true;
        } else {
          this.authenticationError = true;
          this.userLocked = false;
          this.passwordExpired = false;
        }
      });
  }

  public logout() {
    const timeOutFlag = false;
    this.loginService.logout(timeOutFlag);
  }
  public goToForgotPassword() {
    this.router.navigate(["forgotpassword"]);
  }
}
